import type { DistanceLocale } from '@wineryxplorer/shared';
import { CompactVenueCard } from './CompactVenueCard';
import type { CompactVenueCardProps } from './CompactVenueCard';

interface MobileVenueCardsProps {
  venues: CompactVenueCardProps['venue'][] | undefined;
  highlightedVenueId: string | null;
  userLocation: { lat: number; lng: number } | null;
  distanceLocale: DistanceLocale;
  isPending: boolean;
}

/** Venue cards for the Wineries page's mobile map bottom sheet. */
export const MobileVenueCards = ({
  venues,
  highlightedVenueId,
  userLocation,
  distanceLocale,
  isPending,
}: MobileVenueCardsProps) => (
  <div className="space-y-3">
    {venues?.map((venue) => (
      <div
        key={venue._id}
        className={`rounded-lg transition-shadow ${
          highlightedVenueId === venue._id ? 'shadow-lg' : ''
        }`}
      >
        <CompactVenueCard
          venue={venue}
          userLocation={userLocation}
          distanceLocale={distanceLocale}
        />
      </div>
    ))}
    {(!venues || venues.length === 0) && (
      <p className="text-sm text-gray-500 text-center py-4">
        {isPending ? 'Searching...' : 'No venues found in this area'}
      </p>
    )}
  </div>
);
